/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Auto_Crop_UncertainInputs */

const en_mobile_scan_auto_crop_uncertain = /** @type {(inputs: Mobile_Scan_Auto_Crop_UncertainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not identify one clear page. Adjust the corners manually.`)
};

const es_mobile_scan_auto_crop_uncertain = /** @type {(inputs: Mobile_Scan_Auto_Crop_UncertainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo identificar una sola página con claridad. Ajusta las esquinas manualmente.`)
};

/**
* | output |
* | --- |
* | "Could not identify one clear page. Adjust the corners manually." |
*
* @param {Mobile_Scan_Auto_Crop_UncertainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_auto_crop_uncertain = /** @type {((inputs?: Mobile_Scan_Auto_Crop_UncertainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Auto_Crop_UncertainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_auto_crop_uncertain(inputs)
	return en_mobile_scan_auto_crop_uncertain(inputs)
});